import React from 'react'
import Footer from '../components/footer'
import 'bootstrap/dist/css/bootstrap.min.css';

class BaseContainer extends React.Component {
    componentDidMount() {

    }

    render() {
      const { children} = this.props
     
    return (

   
      <div style={{ background:'black' }}>
        {/* 
        <div style={{ background:'white', maxWidth: '100%', margin: '0 auto', textAlign:'center', fontSize:'11pt'}}>
        To be a <i><b>MULTI-ETHNIC</b></i> church where all people find it <i><b>IRRESISTIBLE</b></i>, <i><b>ENGAGING</b></i> and <i><b>IMPACTFUL</b></i>
        </div>*/}
        
        {children}
       
      </div>
    )

  }
}

export default BaseContainer






// WEBPACK FOOTER //
// ./src/components/container.js